import { render, staticRenderFns } from "./ExchangeEdit.vue?vue&type=template&id=1e67ef70&"
import script from "./ExchangeEdit.vue?vue&type=script&lang=js&"
export * from "./ExchangeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports